export default __webpack_public_path__ + "static/media/hermes_915_hero_2.4ad3b800.jpg";